import React from 'react';
import Switch from '@mui/material/Switch';

interface BaseSalesToggleProps {
  initialValue: any;
  rowId: number;
  setValues?: (v: Record<number, boolean>) => void;
  values?: Record<number, boolean>;
}

const BaseSalesToggle: React.FC<BaseSalesToggleProps> = ({
  initialValue,
  rowId,
  setValues,
  values,
}) => {
  const value =
    values && rowId in values
      ? values[rowId]
      : initialValue === true || initialValue === 'True';

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    if (setValues) {
      setValues({
        ...values,
        [rowId]: e.target.checked,
      });
    }
  };

  return (
    <Switch
      checked={!!value}
      color="primary"
      inputProps={{ 'aria-label': 'On/Off toggle' }}
      onChange={handleToggle}
      onClick={(e) => e.stopPropagation()}
    />
  );
};

export default BaseSalesToggle;
